import { useLocation, useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { useVisitorCountry } from "../hooks/useVisitorCountry";
import { detectVisitorCountry } from "../utils/detectCountry";
import { reportWhatsAppConversion, whatsAppUrl } from "../utils/whatsapp";

const Button = styled("button")(() => ({
  position: "fixed",
  right: 20,
  bottom: 92,
  zIndex: 1300,
  width: 56,
  height: 56,
  padding: 0,
  border: 0,
  borderRadius: "50%",
  backgroundColor: "#25D366",
  boxShadow: "0 4px 14px rgba(0, 0, 0, 0.22)",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "&:hover": {
    transform: "scale(1.06)",
    transition: "transform 0.2s",
  },
}));

function WhatsAppIcon() {
  return (
    <svg width="30" height="30" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="#fff"
        d="M12.04 2C6.58 2 2.15 6.43 2.15 11.89c0 1.75.46 3.45 1.32 4.95L2 22l5.3-1.39a9.86 9.86 0 0 0 4.74 1.21h.01c5.46 0 9.89-4.43 9.89-9.89C21.94 6.43 17.5 2 12.04 2zm5.77 13.98c-.24.68-1.41 1.3-1.95 1.38-.5.08-1.13.11-1.83-.12-.42-.13-.96-.31-1.66-.61-2.92-1.26-4.82-4.2-4.97-4.4-.14-.19-1.18-1.57-1.18-3 0-1.42.75-2.12 1.01-2.41.25-.28.55-.35.73-.35h.53c.17 0 .4-.06.62.47.24.55.8 1.95.87 2.09.07.14.12.31.02.5-.09.19-.14.31-.27.48-.14.16-.29.37-.41.5-.14.14-.28.29-.12.56.16.28.72 1.19 1.55 1.93 1.07.95 1.97 1.24 2.25 1.38.28.14.44.12.61-.07.16-.19.7-.81.89-1.09.19-.28.37-.23.62-.14.26.09 1.63.77 1.91.91.28.14.47.21.54.33.07.12.07.68-.17 1.36z"
      />
    </svg>
  );
}

function WhatsappBtn() {
  const loc = useLocation();
  const navigate = useNavigate();
  const { country } = useVisitorCountry();
  const onContactPage = loc.pathname.includes("/contactUs");

  const onClick = async () => {
    if (!onContactPage) {
      navigate("/contactUs/index");
      return;
    }
    const code = country || (await detectVisitorCountry());
    reportWhatsAppConversion(code);
    window.open(whatsAppUrl(code), "_blank", "noopener,noreferrer");
  };

  return (
    <Button type="button" aria-label="WhatsApp" onClick={onClick}>
      <WhatsAppIcon />
    </Button>
  );
}

export default WhatsappBtn;
